import React from "react";
import "./Mission.css"; // optional if you want to style it further
import  img1 from '../../images/mission/1.png'
import  img2 from '../../images/mission/2.png'
const Mission = () => {
  return (
    <section className="mission-vision-section py-5 bg-white">
      <div className="container">
        <div className="row text-center justify-content-center " >
          {/* Mission Card */}
          <div className="col-md-6 mb-4">
            <div className="card p-4 h-100 shadow rounded-4"style={{ border: '1.5px solid #08124d'}}>
              <h3 className="text-color:'#08124d' fw-bold mb-3" >MISSION</h3>
              <div className="mb-3 d-flex justify-content-center align-items-center" style={{ width: 80, height: 80, borderRadius: '50%', background: '#08124d', margin: '0 auto' }}>
                <img src={img1} alt="Mission Icon" style={{ height: 48, width: 48, objectFit: 'contain', display: 'block' }} />
              </div>
              <p className="text-justify">
                
                At THINKBIG INFOTECH, our mission is all about enabling businesses through innovative and reliable IT solutions
                that drive efficiency, enhance productivity and fuel growth. As trusted partners to our clientele, we deliver
                seamless and secure IT experiences, ensuring our clients stay ahead in an ever-evolving digital landscape.
                Leveraging a collaborative approach, we envision a future where technology transforms businesses and creates
                lasting value that’s sustainable.
              </p>
            </div>
          </div>

          {/* Vision Card */}
          <div className="col-md-6 mb-4">
            <div className="card p-4 h-100 shadow rounded-4"style={{ border: '1.5px solid #08124d'}}>
              <h3 className="text-color:'#08124d' fw-bold mb-3">VISION</h3>
              <div className="mb-3 d-flex justify-content-center align-items-center" style={{ width: 80, height: 80, borderRadius: '50%', background: '#08124d', margin: '0 auto' }}>
                <img src={img2} alt="Vision Icon" style={{ height: 48, width: 48, objectFit: 'contain', display: 'block' }} />
              </div>
              <p className="text-justify">
                Empowering the Future, Connecting Possibilities: At THINKBIG INFOTECH, we envision a dynamic tomorrow where our
                cutting-edge IT services define technological innovation. Combining agile solutions and unparalleled expertise,
                we aspire to be the change agents driving our clients' success in an ultra-competitive environment. THINKBIG
                INFOTECH is committed to driving transformative change by pushing the boundaries of innovation, fostering a
                culture of continuous learning and delivering unmatched value to our clients.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
